import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { HeaderSection } from '@/components/sections/HeaderSection';
import { diashow } from '@/lib/images';
import { veroeffentlichteProjektIds } from '@/lib/content/projekte';

const seo = {
  title: 'Marlene Gujan Architektur AG',
  description: 'Marlene Gujan Architektur AG in Igis bietet innovative und massgeschneiderte Architekturlösungen für Ihre Bauprojekte.',
  keywords: 'Architektur, Igis, Marlene Gujan, Bauprojekte, Architekturdesign, innovative Lösungen',
  canonicalUrl: 'https://www.gujan-architektur.ch/',
};

export default function Home({ data }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <HeaderSection data={data} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  const ids = await veroeffentlichteProjektIds();
  return { props: { data: diashow(ids) }, revalidate: 300 };
}
